import { getAmplitudePageNameFromPath } from '@/utils/getPageNameFromPath';
import { getUrlFromPathname } from '@/redux/modules/config';
import { track } from '@/utils/amplitude/analytics/core';
import { TrackingEvents, TrackingPayload } from '@/utils/amplitude/analytics/core.types';
import { useAppSelector } from '@/redux/hooks';
import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';

export enum HeaderNavigationEventType {
    Alerts = 'alerts',
    MyItems = 'myItems',
    WonItems = 'wonItems',
}

type HeaderNavigationEvent = {
    description: string;
    eventName: string;
};

const HEADER_NAVIGATION_EVENTS: Record<HeaderNavigationEventType, HeaderNavigationEvent> = {
    [HeaderNavigationEventType.Alerts]: {
        description: 'User clicks on the "Alert" icon in the top nav',
        eventName: TrackingEvents.GlobalNavigation.HeaderAlertsClicked,
    },
    [HeaderNavigationEventType.MyItems]: {
        description: 'User clicks on the "My Items" icon in the top nav',
        eventName: TrackingEvents.GlobalNavigation.HeaderMyItemsClicked,
    },
    [HeaderNavigationEventType.WonItems]: {
        description: 'User clicks on the "Won Items" icon in the top nav',
        eventName: TrackingEvents.GlobalNavigation.HeaderWonItemsClicked,
    },
};

export const trackHeaderNavigationClickedAnalytics = (eventName: string, payload: TrackingPayload) => {
    track(eventName, payload);
};

export const useTrackHeaderNavigationClicked = () => {
    const { pathname } = useLocation();
    const url = useAppSelector((state) => getUrlFromPathname(state, pathname));

    return useCallback(
        ({ eventType }: { eventType: HeaderNavigationEventType }) => {
            const event = HEADER_NAVIGATION_EVENTS[eventType];
            trackHeaderNavigationClickedAnalytics(event.eventName, {
                description: event.description,
                pageName: getAmplitudePageNameFromPath(pathname),
                url,
            });
        },
        [pathname, url]
    );
};
